
document.addEventListener("DOMContentLoaded", function() {
    var stickyMatches = document.querySelectorAll('.section_sticky');

    widthCheck();

    $(window).on('resize', function () {
        setTimeout(function () {
            widthCheck();
        }, 100);
    });

    function widthCheck() {
        var selectedSection;
        windowWidth = $(window).width();
        if (windowWidth < 992) {
            for (i = 0; i < stickyMatches.length; ++i) {
                selectedSection = stickyMatches[i].parentNode;
                selectedSection.style.position = "inherit";
                selectedSection.style.top = "auto";
                selectedSection.style.zIndex = "auto";
            }
        } else {
            for (i = 0; i < stickyMatches.length; ++i) {
                const topOffset = stickyMatches[i].dataset.stickyOffset || 70;
                const zindexSticky = stickyMatches[i].dataset.stickyZindex;
                selectedSection = stickyMatches[i].parentNode;
                selectedSection.style.position = "sticky";
                selectedSection.style.top = topOffset + "px";
                selectedSection.style.zIndex = zindexSticky;
            }
        }
    }

});

